/* eslint-disable react/prop-types */
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Alert,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import { useCallback, useContext, useEffect, useState } from "react";
import { formatCpfCnpj } from "../../../../../utils/cpfCnpjFormatter";
import { formatPhone } from "../../../../../utils/telefoneFormatter";
import EstadosECidades from "../../../../../data/estadosCidades";
import api from "../../../../../services/axiosConfig";
import Config from "../../../../../config/config";
import { toast } from "react-toastify";
import { copyToClipboard } from "@phntms/react-share";
import { limparCpfCnpj, limparTelefone } from "../../../../../utils/clearMasks";
import { Context } from "../../../../../hooks/useAuthContext";
import Swal from "sweetalert2";
import { UploadButton } from "../../../../../components/UploadButton/UploadButton";
import FullScreenLoader from "../../../../../components/FullScreenLoader/FullScreenLoader";
import { validarSenhaSegura } from "../../../../../utils/ValidatePassword";
import './styles.css'

function ModalNovoAfiliado({ isOpen, onClose, usuarioSelecionado = null, isReadonly }) {
  const { userData, exibirLogs } = useContext(Context);

  const [nome, setNome] = useState("");
  const [porcentagem, setPorcentagem] = useState(5);
  const [linkGrupo, setLinkGrupo] = useState("");
  const [apelido, setApelido] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [telefone, setTelefone] = useState("");
  const [estado, setEstado] = useState("");
  const [cidade, setCidade] = useState("");
  const [cidades, setCidades] = useState([]);
  const [chavesPix, setChavesPix] = useState([]);
  const [utm, setUtm] = useState("");
  const [hideForm, setHideForm] = useState(false);
  const [tipoConta, setTipoConta] = useState("afiliado");
  const [rgFrente, setRgFrente] = useState(null);
  const [rgVerso, setRgVerso] = useState(null);
  const [loading, setLoading] = useState(false);
  const { valido, htmlFeedback } = validarSenhaSegura(password);
  const [membros, setMembros] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [selectedMembros, setSelectedMembros] = useState([]);

  const fetchMembros = async (idAfiliado) => {
    try {
      const response = await api.post(`/auth/user/afiliadoRef`, { afiliadoRef: idAfiliado });
      setSelectedMembros(response.data.data || []);
      
    } catch (error) {
      exibirLogs && console.error("Erro ao buscar membros do afiliado:", error);
      setSelectedMembros([]);
    }
  }

  useEffect(() => {
    if (usuarioSelecionado) {
      fetchMembros(usuarioSelecionado.idAfiliado);
    }
  }, [usuarioSelecionado]);
  

  useEffect(() => {
    if (estado) {
      const estadoSelecionado = EstadosECidades.estados.find(
        (e) => e.sigla === estado
      );
      if (estadoSelecionado) {
        setCidades(estadoSelecionado.cidades);
        setCidade(estadoSelecionado.cidades[0]);
      }
    } else {
      setCidades([]);
      setCidade("");
    }
  }, [estado]);

  useEffect(() => {
    if (usuarioSelecionado) {
      setNome(usuarioSelecionado.nome || "");
      setApelido(usuarioSelecionado.apelido || "");
      setEmail(usuarioSelecionado.email || "");
      setCpfCnpj(formatCpfCnpj(usuarioSelecionado.cpfCnpj || ""));
      setTelefone(formatPhone(usuarioSelecionado.telefone || ""));
      setEstado(usuarioSelecionado.estado || "");
      setCidade(usuarioSelecionado.cidade || "");
      setPorcentagem(usuarioSelecionado.porcentagem || 5);
      setLinkGrupo(usuarioSelecionado.linkGrupo || "");
      setChavesPix(usuarioSelecionado.chavesPix || [])
      setTipoConta(usuarioSelecionado.tipoConta || "afiliado");
      setPassword("");
      setRgFrente(
        usuarioSelecionado.documentoFrente
          ? usuarioSelecionado.documentoFrente
          : ""
      );
      setRgVerso(
        usuarioSelecionado.documentoVerso
          ? usuarioSelecionado.documentoVerso
          : ""
      );
    } else {
      setNome("");
      setApelido("");
      setEmail("");
      setCpfCnpj("");
      setTelefone("");
      setEstado("");
      setCidade("");
      setPorcentagem(5);
      setLinkGrupo("");
      setChavesPix([])
      setTipoConta("afiliado");
      setUtm("");
      setPassword("");
      setRgFrente("");
      setRgVerso("");
      setSelectedMembros([])
      setSearchResults([])
      setMembros("")
    }
    setHideForm(false);
  }, [usuarioSelecionado, isOpen]);

  async function handleSubmit() {
    setLoading(true);

    if (password) {
      setLoading(false);
      if (!valido) {
        Swal.fire({
          title: "Senha fraca!",
          html: htmlFeedback,
          icon: "error",
        });

        
        throw new Error("Modal de cadastro afiliado no painel: Senha fraca!");
      }
    }

    if (!telefone) {
      setLoading(false);
      Swal.fire({
          title: "Não foi possivel adicionar este afiliado!",
          text: "Por favor, preencha um telefone",
          icon: "error",
        });

      throw new Error("Modal de cadastro afiliado no painel: Por favor, preencha um telefone");
    }

    const uidsDosMembros = selectedMembros.map(user => user.uid);

    const novoUsuario = {
      nome,
      apelido,
      email,
      password,
      cpfCnpj: limparCpfCnpj(cpfCnpj),
      telefone: limparTelefone(telefone),
      estado,
      cidade,
      porcentagem,
      linkGrupo,
      status: "ativo",
      statusAprovacao: "Aprovado",
      utmCampaign: utm.trim() !== "" ? utm : undefined,
      tipoConta,
      membros: uidsDosMembros
    };

    if (!usuarioSelecionado) {
      novoUsuario.password = password;
      novoUsuario.status = "ativo";
      novoUsuario.statusAprovacao = "Aprovado";
    }

    try {
      if (usuarioSelecionado) {
        await api.put(
          `/admin/user/update/${usuarioSelecionado.uid}`,
          novoUsuario
        );
        toast.success("Usuário atualizado com sucesso!");

        if (rgFrente || rgVerso) {
          const formData = new FormData();
          formData.append("frente", rgFrente);
          formData.append("verso", rgVerso);

          try {
            await api.patch(
              `/auth/upload-docs/${usuarioSelecionado._id}`,
              formData,
              {
                headers: { "Content-Type": "multipart/form-data" },
              }
            );
          } catch (error) {
            exibirLogs && console.error("Erro ao enviar documentos:", error);
            toast.error(error.response.data.error);
            throw new Error("Modal de cadastro afiliado no painel: " + error.response.data.error || "Erro desconhecido ao enviar documentos");
          }
        }
        onClose();
      } else {
        try {
          const response = await api.post("/admin/users/create", novoUsuario);
          exibirLogs && console.log(response.data);

          if (rgFrente || rgVerso) {
            const idUser = response.data?.data._id;
            const formData = new FormData();
            formData.append("frente", rgFrente);
            formData.append("verso", rgVerso);

            try {
              await api.patch(`/auth/upload-docs/${idUser}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
              });
            } catch (err) {
              exibirLogs && console.error("Erro ao enviar documentos:", err);
              throw new Error("Modal de cadastro afiliado no painel: " + err.response.data.error || "Erro desconhecido ao enviar documentos");

            }
          }
          setHideForm(true);
        } catch (error) {
          exibirLogs && console.error(error);
          toast.error(error.response.data.error);
          throw new Error("Modal de cadastro afiliado no painel: " + error.response.data.error || "Erro desconhecido no cadastro do afiliado");
        }
      }
    } catch (error) {
      exibirLogs &&
        console.error(
          "Erro ao cadastrar usuário:",
          error.response?.data || error
        );
      toast.error(error.response?.data || "Erro desconhecido ao criar afiliado!");
      throw new Error("Modal de cadastro afiliado no painel: " + error.response.data.error || "Erro desconhecido ao criar afiliado!");
    } finally {
      setLoading(false);
    }
  }

  const clearForm = () => {
    setNome("");
    setApelido("");
    setEmail("");
    setPassword("");
    setCpfCnpj("");
    setTelefone("");
    setEstado("");
    setCidade("");
    setPorcentagem(5);
    setLinkGrupo("")
    setCidades([]);
    setUtm("");
    setTipoConta("afiliado");
    setHideForm(false);
    setSelectedMembros([])
    setSearchResults([])
    setMembros("")
  };

   const fetchUsers = useCallback(async (searchQuery) => {
    if (searchQuery.length < 3) {
      setSearchResults([]);
      return;
    }

    setSearchLoading(true);
    try {
      const response = await api.get("/admin/users", {
        params: {
          search: searchQuery,
          limit: 10,
        },
      });

      const fetchedUsers = response.data.data || [];
  
      const availableUsers = fetchedUsers.filter(
        (user) => !selectedMembros.some((selected) => selected.uid === user.uid)
      );

      setSearchResults(availableUsers || []);
    } catch (error) {
      exibirLogs && console.error("Erro ao buscar usuários:", error);
      setSearchResults([]);
    } finally {
      setSearchLoading(false);
    }
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (membros.length >= 3) {
        fetchUsers(membros);
      } else {
        setSearchResults([]);
      }
    }, 100);

    return () => {
      clearTimeout(handler);
    };
  }, [membros, fetchUsers]);

   const handleSearchChange = (e) => {
    setMembros(e.target.value);
   };

  const handleUserSelect = (userToAdd) => {
      if (!selectedMembros.some((member) => member.uid === userToAdd.uid)) {
        setSelectedMembros([...selectedMembros, userToAdd]);
      }
      setMembros(""); 
      setSearchResults([]);
    };

  const handleRemoveUser = (uidToRemove) => {
    setSelectedMembros(
      selectedMembros.filter((member) => member.uid !== uidToRemove)
    );
  };

  const handleCopy = () => {
    const loginData = `Usuário: ${email}\nSenha: ${password}\nLink de acesso: ${Config.URL_DASH}`;
    copyToClipboard(loginData);
    toast.success("Dados copiados!");
    onClose();
    clearForm();
  };

  useEffect(() => {
    if (!isOpen) {
      clearForm();
    }
  }, [isOpen]);

  const handleChavePixChange = (index, field, value) => {
    const novasChaves = [...chavesPix];
    novasChaves[index][field] = value;
    setChavesPix(novasChaves);
  };

  const addChavePix = () => {
    setChavesPix([...chavesPix, { tipo: "email", chave: "", isPrincipal: false }]);
  };

  const removeChavePix = (index) => {
    setChavesPix(chavesPix.filter((_, i) => i !== index));
  };

  return (
    <>
      <Modal isOpen={isOpen} toggle={onClose} size="md" scrollable>
        <ModalHeader toggle={onClose}>
          Novo Afiliado{" "}
        </ModalHeader>
        <ModalBody>
          {loading && <FullScreenLoader />}
          {hideForm ? (
            <>
              <h5>Dados de login:</h5>
              <p>
                <strong>Usuário:</strong> {email}
              </p>
              <p>
                <strong>Senha:</strong> {password}
              </p>
              <p>
                <strong>Acesso ao dashboard:</strong> {Config.URL_DASH}
              </p>
              <Button color="primary" onClick={handleCopy}>
                Copiar
              </Button>
            </>
          ) : (
            <Form>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label for="nomeCompleto">Nome completo</Label>
                    <Input
                      id="nomeCompleto"
                      value={nome}
                      onChange={(e) => setNome(e.target.value)}
                      readOnly={isReadonly}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="apelido">Apelido</Label>
                    <Input
                      id="apelido"
                      value={apelido}
                      onChange={(e) => setApelido(e.target.value)}
                      readOnly={isReadonly}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="email">E-mail</Label>
                    <Input
                      id="email"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      readOnly={isReadonly}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="senha">Crie uma senha segura</Label>
                    <Input
                      id="senha"
                      type="text"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      readOnly={isReadonly}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="cpfCnpj">CPF/CNPJ (Opcional)</Label>
                    <Input
                      id="cpfCnpj"
                      value={cpfCnpj}
                      onChange={(e) =>
                        setCpfCnpj(formatCpfCnpj(e.target.value))
                      }
                      readOnly={isReadonly}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="telefone">Telefone</Label>
                    <Input
                      id="telefone"
                      value={telefone}
                      onChange={(e) => setTelefone(formatPhone(e.target.value))}
                      readOnly={isReadonly}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="tipoConta">Tipo de Conta</Label>
                    <Input
                      id="tipoConta"
                      type="select"
                      value={tipoConta}
                      onChange={(e) => setTipoConta(e.target.value)}
                      disabled
                    >
                      <option value="afiliado">Afiliado</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="estado">Estado</Label>
                    <Input
                      id="estado"
                      type="select"
                      value={estado}
                      onChange={(e) => setEstado(e.target.value)}
                      disabled={isReadonly}
                    >
                      <option value="">Selecione</option>
                      {EstadosECidades.estados.map((estado) => (
                        <option key={estado.sigla} value={estado.sigla}>
                          {estado.nome}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="cidade">Cidade</Label>
                    <Input
                      id="cidade"
                      type="select"
                      value={cidade}
                      onChange={(e) => setCidade(e.target.value)}
                      disabled={isReadonly}
                    >
                      {cidades.map((cidade) => (
                        <option key={cidade} value={cidade}>
                          {cidade}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Label for="porcentagem">Porcentagem da comissão</Label>
                    <Input
                      id="porcentagem"
                      type="number"
                      value={porcentagem}
                      onChange={(e) => setPorcentagem(e.target.value)}
                      readOnly={isReadonly}
                    />
                  </FormGroup>
                </Col>

                <Col md={12}>
                  <FormGroup>
                    <Label for="linkGrupo">Link do Grupo</Label>
                    <Input
                      id="linkGrupo"
                      type="text"
                      value={linkGrupo}
                      onChange={(e) => setLinkGrupo(e.target.value)}
                      readOnly={isReadonly}
                    />
                  </FormGroup>
                </Col>

                <Col md={12}>
                  <Label for="chavePix">Chaves Pix</Label>
                  {chavesPix.length > 0 ? (
                    chavesPix.map((chave, index) => (
                      <Row key={index} className="mb-2" style={{ display: 'flex', alignItems: 'center', width: '100%'}}>
                        <Col md={4}>
                          <FormGroup>
                              {index === 0 && <Label for={`tipo-pix-${index}`}>Tipo</Label>}
                              <Input
                                  id={`tipo-pix-${index}`}
                                  type="select"
                                  value={chave.tipo}
                                  onChange={(e) => handleChavePixChange(index, "tipo", e.target.value)}
                                  disabled={isReadonly}
                              >
                                  <option value="cpf">CPF</option>
                                  <option value="cnpj">CNPJ</option>
                                  <option value="telefone">Telefone</option>
                                  <option value="email">E-mail</option>
                                  <option value="aleatoria">Aleatória</option>
                                  <option value="copiaCola">Copia e cola</option>
                              </Input>
                          </FormGroup>
                        </Col>
                        <Col md={4}>
                          <FormGroup>
                              {index === 0 && <Label for={`chave-pix-${index}`}>Chave</Label>}
                              <Input
                                  id={`chave-pix-${index}`}
                                  type="text"
                                  value={chave.chave}
                                  placeholder="Insira a chave pix"
                                  onChange={(e) => handleChavePixChange(index, "chave", e.target.value)}
                                  readOnly={isReadonly}
                              />
                          </FormGroup>

                        </Col>
                        <Col md={2}>
                          <FormGroup>
                            {index === 0 && <Label for={`chave-pix-${index}`}>Principal</Label>}
                            <br />
                              <Input
                                  id={`chave-pix-${index}`}
                                  type="checkbox"
                                  checked={chave.isPrincipal}
                                  placeholder="Insira a chave pix"
                                  onChange={(e) => handleChavePixChange(index, "isPrincipal", e.target.value)}
                                  disabled={isReadonly}
                              />
                          </FormGroup>
                        </Col>
                        
                        <Col md={2} className="d-flex align-items-end">
                          {!isReadonly && (
                            <Button
                              color="danger"
                              outline
                              onClick={() => removeChavePix(index)}
                            >
                              Remover
                            </Button>
                          )}
                          
                        </Col>
                        
                      </Row>
                    ))
                  ) : (
                    isReadonly && <Alert color="danger">Nenhuma chave pix cadastrada.</Alert>
                  )}

                  <br />
                  {!isReadonly && (
                    <Button color="primary" outline onClick={addChavePix} className="mb-3">
                      Adicionar Chave Pix
                    </Button>
                  )}
                </Col>

                {userData?.tipoConta !== "automacao" && (
                  <>
                    {tipoConta !== "administrador" &&
                      tipoConta !== "automacao" && (
                        <Col md={12} style={{ marginBottom: 20 }}>
                          <Label>Documento</Label>
                          <div className="upload-group">
                            <UploadButton
                              label="Frente"
                              type="file"
                              onFileChange={(file) => {
                                setRgFrente(file);
                              }}
                              file={rgFrente}
                              required
                              isDisabled={isReadonly}
                            />
                            <UploadButton
                              label="Verso"
                              onFileChange={(file) => {
                                setRgVerso(file);
                              }}
                              file={rgVerso}
                              required
                              isDisabled={isReadonly}
                            />
                          </div>
                        </Col>
                      )}
                  </>
                )}
              </Row>

              <Col md={12}>
                  <FormGroup>
                    <Label for="membros">Membros</Label>
                    <Input
                      id="membros"
                      type="text"
                      name="membros"
                      value={membros}
                      onChange={handleSearchChange}
                      placeholder="Pesquisar por nome ou apelido..."
                      autoComplete="off"
                      readOnly={isReadonly}
                      style={{ marginTop: selectedMembros.length > 0 ? '10px' : '0' }}
                    />

                    <div className="tags-container">
                      {selectedMembros.map((user) => (
                        <div key={user.uid} className="user-tag">
                          <span>
                            {user.nome} {user.apelido ? `(${user.apelido})` : ""}
                          </span>
                          <Button
                            close
                            className="remove-tag-btn"
                            onClick={() => handleRemoveUser(user.uid)}
                          />
                        </div>
                      ))}
                    </div>
                  </FormGroup>

                  <ListGroup className="user-suggestions">
                    {searchResults.map((user) => (
                      <ListGroupItem
                        key={user._id}
                        tag="button"
                        action
                        onClick={() => handleUserSelect(user)}
                        className="user-suggestion-item"
                      >
                        {user.nome}{" "} {user.apelido && `(${user.apelido})`}
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                </Col>
            </Form>
          )}

        </ModalBody>
        {!hideForm && userData?.tipoConta !== "financeiro" && (
          <ModalFooter>
            {usuarioSelecionado ? (
              <Button color="primary" onClick={handleSubmit}>
                Salvar
              </Button>
            ) : (
              <Button color="primary" onClick={handleSubmit}>
                Cadastrar conta
              </Button>
            )}
          </ModalFooter>
        )}
      </Modal>
    </>
  );
}

export default ModalNovoAfiliado;
